import { render } from "./NeedToPayNotification.vue?vue&type=template&id=60d63278"
import script from "./NeedToPayNotification.vue?vue&type=script&lang=js"
export * from "./NeedToPayNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/NeedToPayNotification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60d63278"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60d63278', __exports__)) {
    api.reload('60d63278', __exports__)
  }
  
  module.hot.accept("./NeedToPayNotification.vue?vue&type=template&id=60d63278", () => {
    api.rerender('60d63278', render)
  })

}


export default __exports__